exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputBox[data-v-60a74f5a]{width:273px}", ""]);

// exports
